// GENERATED from backend/services/billMemory/core — do not edit; run backend/scripts/sync-bill-memory-core.js
/**
 * Bill Memory — chip ranking (source spec, "Suggestion chips and ranking"). An item stored in a
 * unit family the line cannot be (a grams item for "4 pcs") always goes last; then what this
 * vendor sends, what this business picks for the name, what the bill itself says ("4 pcs" suits
 * "Kaju 4pc"), and name closeness. The leader is pre-selected only when it clearly leads, so a
 * hurried Enter cannot settle a coin-flip. Price is never a signal. Pure.
 */

const PACK_IN_NAME = /(\d+(?:\.\d+)?)\s*(?:pc|pcs|piece|pieces|nos)\b/i;
const PACK_CACHE = new Map();
function packCountOf(name) {
  const key = String(name || '');
  if (PACK_CACHE.has(key)) return PACK_CACHE.get(key);
  const m = PACK_IN_NAME.exec(key);
  const n = m ? Number(m[1]) : null;
  if (PACK_CACHE.size >= 20000) PACK_CACHE.clear();
  PACK_CACHE.set(key, n);
  return n;
}

function rankChips(candidates, { vendorCounts, votes, billUnit, billQty, nameScore, familyOf } = {}) {
  const billFamily = billUnit && familyOf ? familyOf(billUnit) : null;
  const scored = (candidates || []).map((c) => {
    const fam = c.family !== undefined && c.family !== null ? c.family : (familyOf ? familyOf(c.unit_symbol) : null);
    const pc = billFamily === 'count' ? packCountOf(c.name) : null;
    return {
      c,
      fam: !billFamily || !fam || fam === billFamily ? 1 : 0,
      v: (vendorCounts && vendorCounts.get(Number(c.item_id))) || 0,
      vt: (votes && Number(votes[c.item_id])) || 0,
      pack: pc != null && pc === Number(billQty) ? 1 : 0,
      ns: nameScore ? nameScore(c) : 0,
    };
  });
  scored.sort((a, b) => (b.fam - a.fam) || (b.v - a.v) || (b.vt - a.vt) || (b.pack - a.pack) || (b.ns - a.ns));

  let preselect = null;
  let leadReason = 'none';
  if (scored.length === 1) {
    preselect = 0;
    leadReason = 'only';
  } else if (scored.length > 1) {
    const [a, b] = scored;
    if (a.fam > b.fam) leadReason = 'pack';
    else if (a.v > 0 && a.v > b.v) leadReason = 'vendor';
    else if (a.v === b.v && a.vt > 0 && a.vt > b.vt) leadReason = 'votes';
    else if (a.v === b.v && a.vt === b.vt && a.pack > b.pack) leadReason = 'pack';
    if (leadReason !== 'none') preselect = 0;
  }
  const chips = scored.map((s, i) => ({ item_id: Number(s.c.item_id), name: s.c.name, why: i === 0 && leadReason !== 'none' ? leadReason : 'name' }));
  return { chips, preselect, leadReason };
}

// Bigrams per name, memoised: a 100-line bill against 538 items compares the same names thousands of times.
const GRAM_CACHE = new Map();
function grams(s) {
  const key = String(s || '');
  let m = GRAM_CACHE.get(key);
  if (m) return m;
  const t = ` ${key} `;
  m = new Map();
  for (let i = 0; i < t.length - 1; i++) { const g = t.slice(i, i + 2); m.set(g, (m.get(g) || 0) + 1); }
  m.total = t.length - 1;
  if (GRAM_CACHE.size >= 20000) GRAM_CACHE.clear();
  GRAM_CACHE.set(key, m);
  return m;
}

/** Name closeness: Dice coefficient over character bigrams of two match names (0..1). */
function nameCloseness(a, b) {
  const ga = grams(a);
  const gb = grams(b);
  let inter = 0;
  for (const [g, n] of ga) inter += Math.min(n, gb.get(g) || 0);
  const total = ga.total + gb.total;
  return total ? (2 * inter) / total : 0;
}

export { rankChips, nameCloseness };
